import { render, staticRenderFns } from "./RecoverPassword.vue?vue&type=template&id=fd291b28&scoped=true"
import script from "./RecoverPassword.vue?vue&type=script&lang=js"
export * from "./RecoverPassword.vue?vue&type=script&lang=js"
import style0 from "./RecoverPassword.vue?vue&type=style&index=0&id=fd291b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd291b28",
  null
  
)

export default component.exports